module.exports = __webpack_public_path__ + "img/plan_gateway.2f383b8e.svg";